<template>
    <div class="input-button-variant">
        <b-dropdown :variant="currentButtonVariant">
            <template #button-content>
                {{currentButtonVariant}}
            </template>
            <b-dropdown-item v-for="variant in variants" :key="`v-${variant}`" @click="currentButtonVariant = variant" class="pl-2 m-0">
                <b-btn block :variant="variant" class="m-0">{{variant}}</b-btn>
            </b-dropdown-item>
        </b-dropdown>
    </div>
</template>

<script>
import BtnButtonType from "@/components/editor/properties/inputs/btn-button-type.vue";

// input-button-variant #hot-reload-debug
export default {
    name: `input-button-variant`,
    components: {BtnButtonType},
    props: {
        value: {type: String}
    },
    data() {
        return {
            variants: [`primary`, `secondary`, `info`, `success`, `warning`, `danger`, `outline-primary`, `outline-secondary`, `outline-white`, `outline-light`, `outline-info`, `outline-success`, `outline-warning`, `outline-danger`, `light`, `light-primary`, `light-secondary`, `light-info`, `light-success`, `light-warning`, `light-danger`, `dark`, `darkest`]
        }
    },
    computed: {
        currentButtonVariant: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit(`input`, value);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
